import { useEffect } from 'react'
import { getUserAndOrg, isExternalUrl, isSocialMediaLink } from '../utils'
import { pushExternalLinkClickedEvent } from '../utils/GTMPlugin'
import { useGlobalStore } from '../services/store/store'

const useTrackExternalLinks = () => {
	const userToken = useGlobalStore((state) => state.userToken)
	useEffect(() => {
		const { userHash, organisation } = getUserAndOrg()
		const handleExternalLinkClick = (event) => {
			const target = event.target.closest('a')
			if (!target) return

			const href = target.getAttribute('href')
			if (href && isExternalUrl(href)) {
				const isSocialMedia = isSocialMediaLink(href)

				pushExternalLinkClickedEvent(
					organisation,
					userHash,
					href,
					isSocialMedia
				)
			}
		}

		if (userHash && organisation) {
			document.addEventListener('click', handleExternalLinkClick)
		}

		return () => {
			document.removeEventListener('click', handleExternalLinkClick)
		}
	}, [userToken])
}

export default useTrackExternalLinks
